import React from 'react';
import { Heart } from 'lucide-react';
import FavoriteTaxiStands from '../components/FavoriteTaxiStands';

export default function Favorites() {
  return (
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <div className="p-3 bg-gradient-to-br from-red-400 to-red-500 rounded-2xl shadow-lg shadow-red-400/20">
            <Heart className="w-8 h-8 text-gray-900 fill-current" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">Favori Duraklar</h1>
            <p className="text-gray-400">Kaydettiğiniz taksi durakları</p>
          </div>
        </div>

        <FavoriteTaxiStands />

        {/* Boş Durum */}
        <div className="text-center py-12">
          <p className="text-gray-400">
            Henüz favori taksi durağınız bulunmuyor.
            <br />
            Taksi duraklarını favorilere ekleyerek daha hızlı erişebilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
}